import { useEffect, useState } from 'react';

const STORAGE_KEY = 'cw-navigation-version';
const SYNC_EVENT = 'cw-navigation-version-change';

export type NavigationVersion = 'v1' | 'v2';

export function useNavigationVersion() {
  const [version, setVersion] = useState<NavigationVersion>(
    () => (localStorage.getItem(STORAGE_KEY) as NavigationVersion) ?? 'v1',
  );

  useEffect(() => {
    const handler = () => {
      setVersion(
        (localStorage.getItem(STORAGE_KEY) as NavigationVersion) ?? 'v1',
      );
    };
    window.addEventListener(SYNC_EVENT, handler);
    return () => window.removeEventListener(SYNC_EVENT, handler);
  }, []);

  const switchTo = (v: NavigationVersion) => {
    localStorage.setItem(STORAGE_KEY, v);
    setVersion(v);
    window.dispatchEvent(new Event(SYNC_EVENT));
  };

  return {
    version,
    switchToV1: () => switchTo('v1'),
    switchToV2: () => switchTo('v2'),
  };
}
